import * as React from "react";
import { Input } from "@/dentlab/src/components/ui/input";
import { cn } from "@/dentlab/src/lib/util";
import {
	InputWrapper,
	INVALID_CONTROL_CLASS,
} from "@/dentlab/src/components/input-wrapper";

export type InputDensitySize = "sm" | "md" | "lg";

const INPUT_SIZE_CLASS: Record<InputDensitySize, string> = {
	sm: "h-8 text-sm",
	md: "h-10",
	lg: "h-12",
};

export interface CustomTextFieldShadcnProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	validationError?: string | null;
	customHelperText?: string;
	name?: string;
	label?: string;
	required?: boolean;
	classNameInput?: string;
	classNameWrapper?: string;
	densitySize?: InputDensitySize;
	inputHeight?: number;
}

export const CustomTextFieldShadcn = React.memo<CustomTextFieldShadcnProps>(
	({
		validationError,
		customHelperText,
		value,
		onChange,
		label,
		required,
		classNameInput,
		classNameWrapper,
		densitySize,
		inputHeight,
		...rest
	}) => {
		return (
			<InputWrapper
				label={label}
				required={required}
				validationError={validationError}
				customHelperText={customHelperText}
				className={classNameWrapper}
			>
				<Input
					{...rest}
					className={cn(
						"w-full",
						densitySize && INPUT_SIZE_CLASS[densitySize],
						validationError && INVALID_CONTROL_CLASS,
						classNameInput
					)}
					style={
						inputHeight ? { height: `${inputHeight}px` } : undefined
					}
					data-testid={`custom-text-field-${rest.name}`}
					value={value}
					onChange={onChange}
				/>
			</InputWrapper>
		);
	}
);
